import Expand06 from "@untitled-ui/icons-react/build/esm/Expand06";
import { forwardRef, useContext, useEffect, useImperativeHandle, useMemo, useState } from "react";
import styled from "styled-components";
import AppContext from "../../../../AppContext";
import { ReactComponent as Hourglass } from "../../../../assets/icons/hourglass-03.svg";
import { ReactComponent as Sunrise0 } from "../../../../assets/icons/sunrise0.svg";
import { ReactComponent as Sunset0 } from "../../../../assets/icons/sunset0.svg";
import NoImage from "../../../../assets/images/carouselBgImg.jpg";
import { formatDefaultDate, formatPrice } from "../../../../utils/Formatter";
import * as Library from "../../../../utils/Library";
import ChartGauge from "../../../common/charts/ChartGauge";
import ChartGraph from "../../../common/charts/ChartGraph";
import ChartLine from "../../../common/charts/ChartLine";
import FormContainer from "../../../common/forms/FormContainer";
import FormField from "../../../common/forms/FormField";
import SimpleGridContainer from "../../../common/forms/SimpleGridContainer";
import { getDoubleInStringFormat, getIntInStringFormat } from "./GTINsKPIs";
import {
    TooltipAcceleration,
    TooltipGrossMargin,
    TooltipInStores,
    TooltipItemsSold,
    TooltipOutOfStockInDays,
    TooltipOverallStock,
    TooltipPercentageOut,
    TooltipReturns,
    TooltipSellThroughRate,
    TooltipShelfSpeed,
    TooltipStockLevelOverTime,
    TooltipTotalSales,
    TooltipWSStock
} from "./MetricsTooltips";

// #region STYLES
const StyledPage = styled.div`
    &,
    & * {
        box-sizing: border-box;
    }

    .tooltip-container {
        align-self: flex-end;
        position: relative;
        top: 2px;
    }

    .frame-230 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313376 {
        background: var(--buttons-all-platforms-btn-action-blue, #0060cc);
        border-radius: 2px;
        padding: 3px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: center;
        flex-shrink: 0;
        height: 16px;
        position: relative;
    }
    .statuses {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .alert-text {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        text-transform: none;
    }

    .frame-313376 {
        @media (max-width: 1300px) {
            left: calc((100vw - 1300px - 150px) / 2) !important;
        }
    }
    @media (min-width: 1300px) {
        .frame-313376 {
            left: 50% !important;
            transform: translateX(-50%) !important;
        }
    }
`;

const StyledKPIContent = styled.div`
    &.content,
    &.content * {
        box-sizing: border-box;
    }
    &.content {
        padding: 24px 0px 0px 0px;
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        //overflow-x: auto;
        //overflow-y: hidden;
        overflow: hidden;
    }
    .info-cards {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .produc-images {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
        border-radius: 4px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px;
        padding: 8px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        width: 190px;
        position: relative;
    }
    .frame-341 {
        padding: 0px 1px 0px 1px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        overflow: hidden;
    }
    .frame-313715 {
        flex-shrink: 0;
        width: 173px;
        height: 274px;
        position: relative;
        overflow: hidden;
    }
    .rectangle-254 {
        border-radius: 6px;
        width: 173px;
        height: 274px;
        position: absolute;
        left: 0px;
        top: 0px;
        object-fit: cover;
    }
    .expand-06 {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        position: absolute;
        left: 149px;
        top: 253px;
        overflow: visible;
    }
    .in-stores-overall-stock {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 98px;
        height: 298px;
        position: relative;
    }
    .id-info-card {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
        border-radius: 4px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px;
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .id-info-card.active {
        border: 1px solid #0060cc !important;
    }
    .frame-346 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-161 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    ._333-360-nok-60 {
        color: ${props =>
            props.enabled ? "var(--text-icons-green-500, #00b00)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: left;
        position: relative;
    }
    ._333-360-nok-60-span {
        font-size: 16px;
        letter-spacing: -0.015em;
        font-weight: 400;
    }
    ._333-360-nok-60-span2 {
        font-size: 7px;
        letter-spacing: -0.015em;
        font-weight: 400;
    }
    ._333-360-nok-60-span3 {
        font-size: 13px;
        letter-spacing: -0.015em;
        font-weight: 400;
    }
    .gross-margin {
        color: ${props =>
            props.enabled ? "var(--text-icons-gray-100, #d1d1d1)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: left;
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        align-self: stretch;
    }
    .chart-kp-is-background {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
        border-radius: 4px;
        padding: 10px 0px 10px 0px;
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .stock-progress {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .chart-kp-is {
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 278px;
        position: relative;
    }
    .chart {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 204px;
        position: relative;
    }
    .chart-title {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .heading-4-total-visitors {
        color: ${props =>
            props.enabled ? "var(--text-icons-gray-100, #d1d1d1)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        //width: 160px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .info-circle {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .svg {
        align-self: stretch;
        flex-shrink: 0;
        height: 166px;
        position: relative;
        overflow: hidden;

        /* GPU acceleration for better resize performance */
        transform: translateZ(0);
        backface-visibility: hidden;
    }
    .line534 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: auto;
        position: relative;
        overflow: visible;
        border: 1px solid var(--backgrounds-and-lines-n-100, #3c485a);
        margin-bottom: 5px;
    }
    .kp-is {
        padding: 10px 18px 0px 40px;
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 70px;
        position: relative;
    }
    .frame-1000011429 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;

        /* CSS containment to optimize resize performance */
        contain: layout style;

        /* Prevent chart overflow during resize */
        //overflow: hidden;
    }
    .sell-through-rate {
        display: flex;
        flex-direction: row;
        gap: 56px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        height: 50px;
        position: relative;

        /* Workaround for ApexCharts gradual resize bug in flexbox */
        width: 0;
    }
    .frame {
        display: flex;
        flex-direction: column;
        gap: 2px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        height: 58px;
        position: relative;
    }
    .title {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .heading-4-total-visitors2 {
        color: ${props =>
            props.enabled ? "var(--text-icons-gray-100, #d1d1d1)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: left;
        font-size: var(--subtitle-2-font-size, 12px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .acceleration-confidence {
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 4px;
    }
    .acceleration-confidence.low {
        color: var(--text-icons-orange-500, #f90);
    }
    .acceleration-confidence.high {
        color: var(--text-icons-green-500, #0b0);
    }
    .info-circle2 {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .content2 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313289 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 57px;
        position: relative;
    }
    ._5-2 {
        color: ${props =>
            props.enabled ? "var(--text-icons-green-500, #00b00)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: left;
        font-size: 20px;
        letter-spacing: -0.005em;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 26px;
    }
    .frame-313287 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .units-day {
        color: ${props =>
            props.enabled ? "var(--text-icons-gray-100, #d1d1d1)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .svg2 {
        //display: flex;
        flex-direction: row;
        row-gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-content: flex-start;
        //flex: 1;

        height: 34px;
        position: relative;
        overflow: visible;
        width: 100%;

        /* GPU acceleration for better resize performance */
        transform: translateZ(0);
        backface-visibility: hidden;
    }
    .sell-through-rate2 {
        display: flex;
        flex-direction: row;
        gap: 56px;
        align-items: center;
        justify-content: flex-start;
        //flex-shrink: 0;
        flex: 1;
        height: 50px;
        position: relative;

        /* Workaround for ApexCharts gradual resize bug in flexbox */
        width: 0;
    }
    .info-circle3 {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    ._5-8 {
        color: ${props =>
            props.enabled ? "var(--text-icons-orange-500, #ff9900)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: left;
        font-size: 20px;
        letter-spacing: -0.005em;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 26px;
    }
    .days {
        color: ${props =>
            props.enabled ? "var(--text-icons-gray-100, #d1d1d1)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .svg3 {
        //display: flex;
        flex-direction: row;
        row-gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-content: flex-start;
        //flex: 1;
        height: 34px;
        position: relative;
        overflow: visible;
        width: 100%;

        /* GPU acceleration for better resize performance */
        transform: translateZ(0);
        backface-visibility: hidden;
    }
    .info-circle4 {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .frame-3132892 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    ._1-6 {
        color: ${props =>
            props.enabled ? "var(--text-icons-gray-100, #d1d1d1)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 26px;
    }
    ._2-weeks-rate {
        color: ${props =>
            props.enabled ? "var(--text-icons-gray-100, #d1d1d1)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .sunset {
        width: 15px;
        height: 15px;
        position: relative;
        top: 0px;
    }
    ._1-9-dimming {
        font-size: 20px;
    }
    .svg4 {
        //display: flex;
        flex-direction: row;
        row-gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-content: flex-start;
        //flex: 1;
        height: 34px;
        position: relative;
        overflow: visible;
        width: 100%;

        /* GPU acceleration for better resize performance */
        transform: translateZ(0);
        backface-visibility: hidden;
    }
    .line-separator1423 {
        display: block;
        margin: 0;
        padding: 0;
        width: 1px;
        height: 100%;
        border: 1px solid var(--backgrounds-and-lines-n-100, #3c485a);
    }
    .frame-1000011424 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .chart-kp-is2 {
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        height: 278px;
        position: relative;
    }
    .total-score {
        padding: 10px 0px 0px 0px;
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .total-score2 {
        display: flex;
        flex-direction: row;
        gap: 56px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame2 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .info-circle5 {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .content3 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 69px;
        position: relative;
    }
    .frame-29 {
        border-radius: 500px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 78px;
        height: 78px;
        position: relative;
        object-fit: cover;
        aspect-ratio: 1;
    }
    .svg5 {
        flex-shrink: 0;
        width: 129px;
        height: 69px;
        position: relative;
        overflow: hidden;
    }

    .frame-3132893 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0%;
        left: 0%;
        bottom: -0.72%;
        top: 0.72%;
    }
    .shelf-speed {
        color: ${props =>
            props.enabled ? "var(--text-icons-green-500, #00b00)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: center;
        font-size: 22px;
        letter-spacing: -0.005em;
        font-weight: 400;
        position: relative;
        flex: 1;
        width: 128px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
    }
    .fast-mover {
        color: ${props =>
            props.enabled ? "var(--text-icons-green-500, #00b00)" : "var(--text-icons-gray-300, #4f5b6d)"};
    }
    .medium-mover {
        color: ${props =>
            props.enabled ? "var(--text-icons-orange-500, #f90)" : "var(--text-icons-gray-300, #4f5b6d)"};
    }
    .slow-mover {
        color: ${props =>
            props.enabled ? "var(--text-icons-red-500, #ff3636)" : "var(--text-icons-gray-300, #4f5b6d)"};
    }
    .line2 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: auto;
        position: relative;
        overflow: visible;
        border: 1px solid var(--backgrounds-and-lines-n-100, #3c485a);
    }
    .reorders-expected {
        padding: 10px 0px 0px 0px;
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .total-score3 {
        display: flex;
        flex-direction: row;
        gap: 18px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame3 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .info-circle6 {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .frame-3132894 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    ._93-9 {
        color: ${props =>
            props.enabled ? "var(--text-icons-green-500, #00b00)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: left;
        position: relative;
        align-self: stretch;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    ._93-9-span {
        font-size: 35px;
        letter-spacing: -0.005em;
        font-weight: 400;
    }
    ._93-9-span2 {
        font-size: 21px;
        letter-spacing: -0.005em;
        font-weight: 400;
    }
    .heading-4-total-visitors3 {
        color: ${props =>
            props.enabled ? "var(--text-icons-gray-100, #d1d1d1)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .info-circle7 {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    ._102 {
        color: ${props =>
            props.enabled ? "var(--text-icons-green-500, #00b00)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: left;
        font-size: 35px;
        letter-spacing: -0.005em;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
`;

const StyledSalesChartTooltip = styled.div`
    .styled-tooltip {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 6px;
        padding: 6px 10px 6px 10px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        width: 159px;
        position: relative;
    }
    .tooltip-container {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
`;
// #endregion

const HIDE_CHARTLINES = false;
const HIDE_CHARTGRAPH = false;

export default forwardRef(function HeadlineKPIs(props, ref) {
    // #region PROPS
    const {
        lastUpdatedDateTime,
        dataAsOfDateTime = "",
        kpiData,
        enabled = true,
        currentGTIN = "All",
        onGtinClicked,
        datePeriod = ""
    } = props;
    // #endregion

    console.log("kpiData", kpiData);

    // #region STATES
    const { aiChatSidePanelOpen } = useContext(AppContext);
    const [gtinsFromFieldOptions, setGtinsFromFieldOptions] = useState([
        {
            value: "",
            name: ""
        }
    ]);
    const [formData, setFormData] = useState({
        labelBrandID: null,
        labelBrandName: "",
        styleName: "",
        styleNr: "",
        gtin: null
    });
    const [kpiContent, setKpiContent] = useState({
        inStores: null,
        itemsSold: null,
        returns: null,
        returnsTotalValue: null,
        overallStock: null,
        totalSales: null,
        totalCosts: null,
        totalDiscountOfSales: null,
        grossMargin: null,
        grossMarginPercentage: null,
        sellThroughRate: null,
        daysOfCoverBlended: null, //not used
        daysOfCoverFullStockOut: null,
        acceleration: null,
        accelerationConfidence: null,
        accelerationEnum: null,
        shelfSpeed: null,
        outOfOverallStock: null,
        reordersOfItems: null,
        supplierStock: null,
        image: ""
    });

    // State to track if window is being resized
    const [isResizing, setIsResizing] = useState(false);
    // #endregion

    // #region CHARTS DATA
    const stockProgressChartData = useMemo(() => {
        const data = [];

        if (currentGTIN === "All" && kpiData?.allVariantsData?.salesGraphData) {
            const graphData = kpiData?.allVariantsData?.salesGraphData || [];

            graphData.forEach(graphItem => {
                const graphItemDate = graphItem.date;
                const graphItemDateObject = new Date(graphItemDate);

                data.push([graphItemDateObject, graphItem?.unitsSold || 0]);
                //For testing: data.unshift([new Date("2025-04-29T00:00:00.000Z"), 30]);
            });
        } else {
            //We need to search each "gtinsData" for barcode that is the same as the currentGTIN
            const graphData =
                kpiData?.gtinsData?.find(gtinsData => gtinsData.barcode === currentGTIN)?.salesGraphData || [];

            graphData.forEach(graphItem => {
                const graphItemDate = graphItem.date;
                const graphItemDateObject = new Date(graphItemDate);

                data.push([graphItemDateObject, graphItem?.unitsSold || 0]);
            });
        }

        return [
            {
                name: "Sales Progress",
                data: data
            }
        ];
    }, [kpiData, currentGTIN]);

    const sellThroughRateChartData = useMemo(() => {
        const data = [];

        if (currentGTIN === "All" && kpiData?.allVariantsData?.graphData) {
            const graphData = kpiData?.allVariantsData?.graphData || [];

            graphData.forEach(graphItem => {
                //const graphItemDate = graphItem.date;
                //const graphItemDateObject = new Date(graphItemDate);

                data.push(graphItem?.sellThroughRate || 0);
            });
        } else {
            const graphData = kpiData?.gtinsData?.find(gtinsData => gtinsData.barcode === currentGTIN)?.graphData || [];

            graphData.forEach(graphItem => {
                //const graphItemDate = graphItem.date;
                //const graphItemDateObject = new Date(graphItemDate);

                data.push(graphItem?.sellThroughRate || 0);
            });
        }

        //if length > 0 then duplicate last value 2x
        if (data.length > 0) {
            data.push(data[data.length - 1]);
            data.push(data[data.length - 1]);
        }

        return [
            {
                name: "Sell Through Rate",
                data: data
            }
        ];
    }, [kpiData, currentGTIN]);

    const daysOfCoverChartData = useMemo(() => {
        const data = [];

        if (currentGTIN === "All" && kpiData?.allVariantsData?.graphData) {
            const graphData = kpiData?.allVariantsData?.graphData || [];

            graphData.forEach(graphItem => {
                //const graphItemDate = graphItem.date;
                //const graphItemDateObject = new Date(graphItemDate);

                data.push(graphItem?.daysOfCoverFullStockOut || 0);
            });
        } else {
            const graphData = kpiData?.gtinsData?.find(gtinsData => gtinsData.barcode === currentGTIN)?.graphData || [];

            graphData.forEach(graphItem => {
                //const graphItemDate = graphItem.date;
                //const graphItemDateObject = new Date(graphItemDate);

                data.push(graphItem?.daysOfCoverFullStockOut || 0);
            });
        }

        //if length > 0 then duplicate last value 2x
        if (data.length > 0) {
            data.push(data[data.length - 1]);
            data.push(data[data.length - 1]);
        }

        return [
            {
                name: "Days of Cover",
                data: data
            }
        ];
    }, [kpiData, currentGTIN]);

    const accelerationChartData = useMemo(() => {
        const data = [];

        if (currentGTIN === "All" && kpiData?.allVariantsData?.graphData) {
            const graphData = kpiData?.allVariantsData?.graphData || [];

            graphData.forEach(graphItem => {
                //const graphItemDate = graphItem.date;
                //const graphItemDateObject = new Date(graphItemDate);

                data.push(graphItem?.acceleration || 0);
            });
        } else {
            const graphData = kpiData?.gtinsData?.find(gtinsData => gtinsData.barcode === currentGTIN)?.graphData || [];

            graphData.forEach(graphItem => {
                //const graphItemDate = graphItem.date;
                //const graphItemDateObject = new Date(graphItemDate);

                data.push(graphItem?.acceleration || 0);
            });
        }

        //if length > 0 then duplicate last value
        if (data.length > 0) {
            data.push(data[data.length - 1]);
            data.push(data[data.length - 1]);
        }

        return [
            {
                name: "Acceleration",
                data: data
            }
        ];
    }, [kpiData, currentGTIN]);
    // #endregion

    // #region METHODS
    const getChartTooltipData = index => {
        if (currentGTIN === "All" && kpiData?.allVariantsData?.salesGraphData) {
            const graphData = kpiData?.allVariantsData?.salesGraphData || [];

            return graphData?.[index];
        } else {
            const graphData =
                kpiData?.gtinsData?.find(gtinsData => gtinsData.barcode === currentGTIN)?.salesGraphData || [];

            return graphData?.[index];
        }
    };

    const onFormFieldChange = (formFieldName, formFieldValue = "") => {
        setFormData({
            ...formData,
            [formFieldName]: formFieldValue
        });
    };

    const updateStatesWithGtin = ({ newGTIN }) => {
        if (!kpiData) return;
        const { allVariantsData, gtinsData, productData } = kpiData;

        const sourceGtinData =
            currentGTIN === "All" ? allVariantsData : gtinsData?.find(item => item.barcode === currentGTIN);

        if (!sourceGtinData) {
            Library.showToastMessage({
                title: "An error occurred",
                message: `No data found for the selected GTIN: ${newGTIN}`,
                type: "error"
            });
            return;
        }

        console.log("Source GTIN data for updateStatesWithGtin:", sourceGtinData);

        setFormData({
            ...formData,
            gtin: newGTIN
        });

        /* Data examples:
        productData example:
        {
            "labelBrandID": "6932e0da268574cdbbf82e0a",
            "productID": "693616f10c0db5f44221f0ba",
            "productName": "TWIST BRAIDED SOFT STRUCTURE",
            "productStyleCode": "TWIST BRAIDED SOFT STRUCTURE",
            "productStatus": "Active",
            "labelBrandName": "Hvisk fake - SPY"
        }

        gtinsData example:
        [
            {
                "_id": "693616f10c0db5f44221f0c3",
                "barcode": "5714196141007",
                "colorName": "Black",
                "colorHexacode": "000000",
                "size": "3pcs",
                "images": [
                    {
                        "name": "-",
                        "URL": "https://hvisk.spysystem.dk/file/377ac0a6-72c4-49e0-ba93-1dec69ad2133/8c2032d6-5e8b-4915-a28b-2339fb7af415/IMG_9106-3.png"
                    }
                ],
                "stockAndPricesData": [
                    {
                        "stockLog": [
                            {
                                "stock": 7,
                                "date": "2025-12-09T17:38:11.778Z"
                            }
                        ]
                    }
                ],
                "totalStock": 7,
                "totalStoresWithStock": 1,
                "fromDate": "2025-12-09T17:38:11.778Z",
                "toDate": "2025-12-09T17:38:11.778Z",
                "unitsSold": 0,
                "sellThroughRate": 0,
                "daysOfCover": null,
                "daysOfCoverEnum": "NO_VELOCITY",
                "acceleration": null,
                "accelerationEnum": null,
                "totalScore": null,
                "unitsSoldPercentage": 0,
                "shelfSpeed": "Slow",
                "cutOffPressureStock": null,
                "urgencyScore": null,
                "priorityScore": null,
                "seasonFactor": null,
                "reorderQuantity": null,
                "totalSales": null,
                "grossMargin": null,
                "returns": null,
                "graphData": [
                    {
                        "date": "2025-12-09",
                        "stockQuantity": 7,
                        "sellThroughRate": 0,
                        "daysOfCover": null,
                        "acceleration": null
                    }
                ]
            }
        ]
        
        allVariantsData example:
        {
            "totalStock": 7,
            "totalStoresWithStock": 1,
            "fromDate": "2025-12-09T17:38:11.778Z",
            "toDate": "2025-12-09T17:38:11.778Z",
            "unitsSold": 0,
            "sellThroughRate": 0,
            "daysOfCover": null,
            "daysOfCoverEnum": "NO_VELOCITY",
            "acceleration": null,
            "accelerationEnum": null,
            "totalScore": null,
            "unitsSoldPercentage": 0,
            "shelfSpeed": "Slow",
            "cutOffPressureStock": null,
            "urgencyScore": null,
            "priorityScore": null,
            "seasonFactor": null,
            "reorderQuantity": null,
            "totalSales": null,
            "grossMargin": null,
            "returns": null,
            "graphData": [
                {
                    "date": "2025-12-09",
                    "stockQuantity": 7,
                    "sellThroughRate": 0,
                    "daysOfCover": null,
                    "acceleration": null
                }
            ]
        }
        */

        setFormData({
            labelBrandID: productData?.labelBrandID,
            labelBrandName: productData?.labelBrandName ?? "--",
            styleName: productData?.productName ?? "--", //Style name is the product name
            styleNr: productData?.productStyleCode ?? "--", //Style nr is the product style code
            gtin: ""
        });

        const gtins = gtinsData?.map(item => {
            return {
                //name: `${item?.colorName}  |  ${item?.size}  |  ${item?.barcode}`,
                name: item?.colorName,
                value: item?.barcode,
                colorName: item?.colorName,
                barcode: item?.barcode,
                size: item?.size,
                //locked: item?.statusEnum !== "Active",
                selected: currentGTIN === item?.barcode
            };
        });

        gtins.unshift({
            name: "All variants",
            value: "All",
            colorName: "",
            barcode: "",
            size: "",
            selected: currentGTIN === "All"
        });

        setGtinsFromFieldOptions(gtins);

        const image =
            newGTIN === "All"
                ? gtinsData?.[0]?.images?.[0]?.URL
                : gtinsData?.find(item => item?.barcode === newGTIN)?.images?.[0]?.URL;

        if (!sourceGtinData) {
            Library.showToastMessage({
                title: "An error occurred",
                message: `No data found for the selected GTIN: ${currentGTIN}`,
                type: "error"
            });
            return;
        }

        setKpiContent({
            inStores: sourceGtinData?.totalStoresWithStock,
            itemsSold: sourceGtinData?.unitsSold,
            returns: sourceGtinData?.returns,
            returnsTotalValue: sourceGtinData?.returnsTotalValue,
            overallStock: sourceGtinData?.totalStock,
            totalSales: sourceGtinData?.totalSales,
            totalCosts: sourceGtinData?.totalCosts,
            totalDiscountOfSales: sourceGtinData?.totalDiscountOfSales,
            grossMargin: sourceGtinData?.grossMargin,
            grossMarginPercentage: sourceGtinData?.grossMarginPercentage,
            sellThroughRate: sourceGtinData?.sellThroughRate,
            daysOfCoverBlended: sourceGtinData?.daysOfCoverBlended, //NOT USED
            daysOfCoverFullStockOut: sourceGtinData?.daysOfCoverFullStockOut,
            acceleration: sourceGtinData?.acceleration,
            accelerationConfidence: sourceGtinData?.accelerationConfidence,
            accelerationEnum: sourceGtinData?.accelerationEnum,
            shelfSpeed: sourceGtinData?.shelfSpeed,
            outOfOverallStock: sourceGtinData?.unitsSoldPercentage,
            reordersOfItems: sourceGtinData?.reorderQuantity,
            supplierStock: sourceGtinData?.supplierStock,
            image
        });
    };

    const handleResetView = () => {
        setGtinsFromFieldOptions([
            {
                value: "",
                name: ""
            }
        ]);

        setFormData({
            labelBrandID: null,
            labelBrandName: "",
            styleName: "",
            styleNr: "",
            gtin: null
        });

        setKpiContent({
            inStores: null,
            itemsSold: null,
            returns: null,
            returnsTotalValue: null,
            overallStock: null,
            totalSales: null,
            totalCosts: null,
            totalDiscountOfSales: null,
            grossMargin: null,
            grossMarginPercentage: null,
            sellThroughRate: null,
            daysOfCoverBlended: null,
            daysOfCoverFullStockOut: null,
            acceleration: null,
            accelerationConfidence: null,
            accelerationEnum: null,
            shelfSpeed: null,
            outOfOverallStock: null,
            reordersOfItems: null,
            supplierStock: null,
            image: ""
        });
    };
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        updateStatesWithGtin({ newGTIN: currentGTIN });
    }, [currentGTIN, kpiData]);

    // Handle window resize with debounce to prevent animation lag
    useEffect(() => {
        let resizeTimer;

        const handleResizeStart = () => {
            setIsResizing(true);
            clearTimeout(resizeTimer);

            // Set isResizing to false after 150ms of no resize events
            resizeTimer = setTimeout(() => {
                setIsResizing(false);
            }, 150);
        };

        window.addEventListener("resize", handleResizeStart);

        return () => {
            window.removeEventListener("resize", handleResizeStart);
            clearTimeout(resizeTimer);
        };
    }, []);

    useEffect(() => {
        if (aiChatSidePanelOpen) {
            setIsResizing(true);
            setTimeout(() => {
                setIsResizing(false);
            }, 150);
        }

        setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
        }, 250);

        window.dispatchEvent(new Event("resize"));
    }, [aiChatSidePanelOpen]);
    // #endregion

    // #region RENDER
    useImperativeHandle(ref, () => ({
        resetView: handleResetView
    }));

    return (
        <>
            <StyledPage>
                <FormContainer
                    title={
                        <div
                            className={`flex gap-12px ${enabled ? "text-white" : "text-inactive"} text-transform-none`}>
                            HEADLINE KPIs
                        </div>
                    }
                    middleComponent={
                        !datePeriod.isMaxDate && (
                            <div className="frame-313376">
                                <div className="statuses">
                                    <div className="alert-text">
                                        Period-dependent data is highlighted in blue. STR, Out of stock and ACCEL are
                                        fixed to the Max period.
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    rightComponent={
                        enabled && (
                            <>
                                <div className="last-update mr-24px d-none">
                                    Data as of: {dataAsOfDateTime ? `${dataAsOfDateTime}` : "--"}
                                </div>
                                <div className="last-update">Last update: {lastUpdatedDateTime ?? "--"}</div>
                            </>
                        )
                    }>
                    <div className="flex gap-16px flex-column">
                        <div className="frame-230">
                            <SimpleGridContainer className="w-100" type="fieldsPerLine" fieldsPerLine={4}>
                                <FormField
                                    title="Brand"
                                    type="text"
                                    varName="brand"
                                    value={formData.labelBrandName}
                                    onTextChange={text => onFormFieldChange("brand", text)}
                                    requiredType="locked"
                                    styling={{ textColorOverride: "#00BB00" }}
                                    tooltip="Select the brand you want to analyze. All KPIs below update based on the chosen brand, style and Variants filter."
                                    assistiveText=" "
                                />
                                <FormField
                                    title="Style name"
                                    type="text"
                                    varName="styleName"
                                    value={formData.styleName}
                                    onTextChange={text => onFormFieldChange("styleName", text)}
                                    requiredType="locked"
                                    styling={{ textColorOverride: "#00BB00" }}
                                    tooltip="The product style (item) you’re analyzing. KPIs are calculated for this style and the selected variant scope."
                                    assistiveText=" "
                                />
                                <FormField
                                    title="Style nr"
                                    type="text"
                                    varName="styleNr"
                                    value={formData.styleNr}
                                    onTextChange={text => onFormFieldChange("styleNr", text)}
                                    requiredType="locked"
                                    styling={{ textColorOverride: "#00BB00" }}
                                    tooltip="Internal style/article number for this product. Useful to confirm you’re viewing the correct style."
                                    assistiveText=" "
                                />
                                <FormField
                                    type="dropdown"
                                    title="Variant"
                                    dropdownData={gtinsFromFieldOptions}
                                    varName="gtin"
                                    isDropdownMultiselect={false}
                                    useDropdownPlaceholderAsTag={false}
                                    onDropdownChange={value => onGtinClicked(value?.value)}
                                    tooltip="Choose which SKU(s) to analyze: one variant or All variants. All KPIs and the table below update to match your selection."
                                    requiredType={!enabled ? "locked" : "simple"}
                                    dropdownSettings={{
                                        hasMiddleFields: true,
                                        middleFieldKeyName: "size",
                                        hasDescriptionFields: true,
                                        descriptionFieldKeyName: "barcode",
                                        //mainFieldStyle: { color: "#00BB00" },
                                        middleFieldStyle: { fontStyle: "normal" },
                                        descriptionStyle: { fontStyle: "normal" }
                                    }}
                                    assistiveText=" "
                                />
                            </SimpleGridContainer>
                        </div>
                    </div>

                    <StyledKPIContent className="content" enabled={enabled}>
                        <div className="produc-images">
                            <div className="frame-341">
                                <div className="frame-313715">
                                    <img
                                        alt="Product"
                                        className="rectangle-254"
                                        src={kpiContent?.image}
                                        onError={e => (e.target.src = NoImage)}
                                    />
                                </div>
                            </div>
                            <Expand06 className="expand-06 d-none" />
                        </div>

                        <div className="info-cards">
                            <div className="in-stores-overall-stock">
                                <InfoCard
                                    cardTitle={
                                        <>
                                            Items sold <span style={{ fontSize: 12 }}>(net)</span>
                                        </>
                                    }
                                    tooltip={
                                        <TooltipItemsSold
                                            enabled={enabled}
                                            data={{
                                                consumer_sales: getIntInStringFormat(
                                                    (kpiContent?.returns ?? 0) + (kpiContent?.itemsSold ?? 0)
                                                ),
                                                returns: getIntInStringFormat(kpiContent?.returns),
                                                items_sold_net: getIntInStringFormat(kpiContent?.itemsSold),
                                                transfers_out: "--",
                                                transfers_in: "--",
                                                stock_adjustments: "--",
                                                sync_adjustments: "--"
                                            }}
                                        />
                                    }
                                    value={getIntInStringFormat(kpiContent?.itemsSold ?? "-")}
                                    isActive={!datePeriod.isMaxDate && enabled}
                                />
                                <InfoCard
                                    cardTitle={<>Total sales</>}
                                    tooltip={
                                        <TooltipTotalSales
                                            enabled={enabled}
                                            data={{
                                                total_sales: formatPrice(kpiContent?.totalSales, "NOK", "--", false, 0),
                                                gross_sales: "--",
                                                returns:
                                                    "-" +
                                                    formatPrice(kpiContent?.returnsTotalValue, "NOK", "-", false, 0),
                                                discounts: formatPrice(
                                                    kpiContent?.totalDiscountOfSales,
                                                    "NOK",
                                                    "--",
                                                    false,
                                                    0
                                                )
                                            }}
                                        />
                                    }
                                    value={getIntInStringFormat(kpiContent?.totalSales ?? "-")}
                                    currency={kpiContent?.totalSales ? "NOK" : null}
                                    isActive={!datePeriod.isMaxDate && enabled}
                                />
                            </div>
                            <div className="in-stores-overall-stock">
                                <InfoCard
                                    cardTitle={<>Returns</>}
                                    tooltip={
                                        <TooltipReturns
                                            enabled={enabled}
                                            data={{
                                                returned_items: getIntInStringFormat(kpiContent?.returns),
                                                returned_transactions: "--",
                                                return_value: formatPrice(
                                                    kpiContent?.returnsTotalValue,
                                                    "NOK",
                                                    "--",
                                                    false,
                                                    0
                                                ),
                                                transfers_in: "--",
                                                stock_adjustments: "--",
                                                sync_adjustments: "--"
                                            }}
                                        />
                                    }
                                    value={getIntInStringFormat(kpiContent?.returns ?? "-")}
                                    isActive={!datePeriod.isMaxDate && enabled}
                                />
                                <InfoCard
                                    cardTitle={
                                        <>
                                            Gross <br /> margin
                                        </>
                                    }
                                    tooltip={
                                        <TooltipGrossMargin
                                            enabled={enabled}
                                            data={{
                                                gross_margin: formatPrice(
                                                    kpiContent?.grossMargin,
                                                    "NOK",
                                                    "--",
                                                    false,
                                                    0
                                                ),
                                                gross_margin_pct: kpiContent?.grossMarginPercentage
                                                    ? `${getDoubleInStringFormat(kpiContent?.grossMarginPercentage, 1)}%`
                                                    : null,
                                                total_sales: formatPrice(kpiContent?.totalSales, "NOK", "--", false, 0),
                                                item_cost: formatPrice(kpiContent?.totalCosts, "NOK", "--", false, 0)
                                            }}
                                        />
                                    }
                                    value={getIntInStringFormat(kpiContent?.grossMargin ?? "-")}
                                    currency={kpiContent?.grossMargin ? "NOK" : null}
                                    percentage={
                                        kpiContent?.grossMarginPercentage
                                            ? `${getDoubleInStringFormat(kpiContent?.grossMarginPercentage, 1)}%`
                                            : null
                                    }
                                    isActive={!datePeriod.isMaxDate && enabled}
                                />
                            </div>
                            <div className="in-stores-overall-stock">
                                <InfoCard
                                    cardTitle={
                                        <>
                                            In <br /> stores
                                        </>
                                    }
                                    tooltip={
                                        <TooltipInStores
                                            enabled={enabled}
                                            data={{ in_stores_stock: getIntInStringFormat(kpiContent?.inStores) }}
                                        />
                                    }
                                    value={getIntInStringFormat(kpiContent?.inStores ?? "-")}
                                />
                                <InfoCard
                                    cardTitle={<>Overall stock</>}
                                    tooltip={
                                        <TooltipOverallStock
                                            enabled={enabled}
                                            data={{
                                                sellable_stock: getIntInStringFormat(kpiContent?.overallStock),
                                                negative_stock: "--"
                                            }}
                                        />
                                    }
                                    value={getIntInStringFormat(kpiContent?.overallStock ?? "-")}
                                />
                            </div>
                        </div>

                        <div className="chart-kp-is-background">
                            <div className="stock-progress">
                                <div className="chart-kp-is">
                                    <div className="chart">
                                        <div className="chart-title">
                                            <TooltipStockLevelOverTime enabled={enabled} />
                                            <div className="heading-4-total-visitors lh-normal">SALES OVER TIME</div>
                                        </div>
                                        <div className={`svg ${HIDE_CHARTGRAPH ? "d-none" : ""}`}>
                                            <ChartGraph
                                                data={stockProgressChartData}
                                                enabled={enabled}
                                                isResizing={isResizing}
                                                csvExportCategoryName="Date"
                                                tooltipComponent={data => (
                                                    <SalesChartTooltip
                                                        data={data}
                                                        getChartTooltipData={getChartTooltipData}
                                                    />
                                                )}
                                                showXAxisTooltip={false}
                                            />
                                        </div>
                                    </div>
                                    <div className="line534" />
                                    <div className="kp-is">
                                        <div className="frame-1000011429">
                                            <div className="sell-through-rate">
                                                <div className="frame">
                                                    <div className="title">
                                                        <TooltipSellThroughRate enabled={enabled} />
                                                        <div className="heading-4-total-visitors2 lh-normal">
                                                            SELL-THROUGH RATE
                                                        </div>
                                                    </div>
                                                    <div className="content2" style={{ marginLeft: "15px" }}>
                                                        <div className="frame-313289">
                                                            <div className="_5-2">
                                                                {getDoubleInStringFormat(
                                                                    kpiContent?.sellThroughRate ?? "-",
                                                                    3
                                                                )}
                                                            </div>
                                                            <div className="frame-313287">
                                                                <div className="units-day">Units/day</div>
                                                            </div>
                                                        </div>
                                                        <div className={`svg2 ${HIDE_CHARTLINES ? "d-none" : ""}`}>
                                                            <ChartLine
                                                                data={sellThroughRateChartData}
                                                                isResizing={isResizing}
                                                                formatting={{
                                                                    colorStops: [
                                                                        { offset: 0, color: "#1E2631", opacity: 1 },
                                                                        { offset: 100, color: "#00BB00", opacity: 1 }
                                                                    ]
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="sell-through-rate2">
                                                <div className="frame">
                                                    <div className="title">
                                                        <TooltipOutOfStockInDays enabled={enabled} />
                                                        <div className="heading-4-total-visitors2 lh-normal">
                                                            OUT OF STOCK IN
                                                        </div>
                                                    </div>
                                                    <div className="content2" style={{ marginLeft: "15px" }}>
                                                        <div className="frame-313289">
                                                            <div className="_5-8">
                                                                {getDoubleInStringFormat(
                                                                    kpiContent?.daysOfCoverFullStockOut ?? "-",
                                                                    1
                                                                )}
                                                            </div>
                                                            <div className="frame-313287">
                                                                <div className="days">Days</div>
                                                            </div>
                                                        </div>
                                                        <div className={`svg3 ${HIDE_CHARTLINES ? "d-none" : ""}`}>
                                                            <ChartLine
                                                                data={daysOfCoverChartData}
                                                                isResizing={isResizing}
                                                                formatting={{
                                                                    colorStops: [
                                                                        { offset: 0, color: "#1E2631", opacity: 1 },
                                                                        { offset: 100, color: "#FF9900", opacity: 1 }
                                                                    ]
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="sell-through-rate2">
                                                <div className="frame">
                                                    <div className="title">
                                                        <TooltipAcceleration enabled={enabled} />
                                                        <div className="heading-4-total-visitors2 lh-normal">
                                                            ACCELERATION
                                                            <span
                                                                className={`acceleration-confidence ${kpiContent?.accelerationConfidence?.toLowerCase()}`}>
                                                                {kpiContent?.accelerationConfidence
                                                                    ? `${kpiContent?.accelerationConfidence} CONFIDENCE`
                                                                    : ""}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="content2" style={{ marginLeft: "15px" }}>
                                                        <div className="frame-3132892">
                                                            <div className="_1-6">
                                                                {getAccelerationText(kpiContent?.accelerationEnum)}
                                                            </div>
                                                            <div className="frame-313287">
                                                                <div className="_2-weeks-rate">2 weeks rate</div>
                                                            </div>
                                                        </div>
                                                        <div className={`svg4 ${HIDE_CHARTLINES ? "d-none" : ""}`}>
                                                            <ChartLine
                                                                data={accelerationChartData}
                                                                isResizing={isResizing}
                                                                formatting={{
                                                                    colorStops: [
                                                                        { offset: 0, color: "#1E2631", opacity: 1 },
                                                                        { offset: 100, color: "#FF3636", opacity: 1 }
                                                                    ]
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <hr className="line-separator1423" />

                            <div className="frame-1000011424" style={{ width: "234px" }}>
                                <div className="chart-kp-is2" style={{ width: "227px" }}>
                                    <div className="total-score">
                                        <div className="total-score2">
                                            <div className="frame2">
                                                <div className="title">
                                                    <TooltipShelfSpeed enabled={enabled} />
                                                    <div className="heading-4-total-visitors2 lh-normal">
                                                        SHELF SPEED
                                                    </div>
                                                </div>
                                                <div className="content3">
                                                    <div className="frame-29">
                                                        <ChartGauge
                                                            index={Math.random()}
                                                            value={
                                                                kpiContent?.shelfSpeed === "Fast"
                                                                    ? 88
                                                                    : kpiContent?.shelfSpeed === "Watchlist" ||
                                                                        kpiContent?.shelfSpeed === "Watch List"
                                                                      ? 50
                                                                      : 15
                                                            }
                                                            enabled={
                                                                enabled &&
                                                                ["Fast", "Watchlist", "Watch List", "Slow"].includes(
                                                                    kpiContent?.shelfSpeed
                                                                )
                                                            }
                                                        />
                                                    </div>

                                                    <div className="svg5">
                                                        <div className="frame-3132893">
                                                            <div
                                                                className={`shelf-speed ${
                                                                    kpiContent?.shelfSpeed === "Fast"
                                                                        ? "fast-mover"
                                                                        : kpiContent?.shelfSpeed === "Watchlist" ||
                                                                            kpiContent?.shelfSpeed === "Watch List"
                                                                          ? "medium-mover"
                                                                          : kpiContent?.shelfSpeed === "Slow"
                                                                            ? "slow-mover"
                                                                            : "text-inactive"
                                                                }`}>
                                                                {!["Fast", "Watchlist", "Watch List", "Slow"].includes(
                                                                    kpiContent?.shelfSpeed
                                                                ) ? (
                                                                    "--"
                                                                ) : kpiContent?.shelfSpeed === "Watchlist" ||
                                                                  kpiContent?.shelfSpeed === "Watch List" ? (
                                                                    <>
                                                                        WATCH
                                                                        <br />
                                                                        LIST
                                                                    </>
                                                                ) : (
                                                                    `${kpiContent?.shelfSpeed} MOVER`
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="line2" />
                                    <div className="reorders-expected">
                                        <div className="total-score3">
                                            <div className="frame3">
                                                <div className="title">
                                                    <TooltipPercentageOut enabled={enabled} />
                                                    <div className="heading-4-total-visitors2 lh-normal">% OUT</div>
                                                </div>
                                                <div className="content3">
                                                    <div className="frame-3132894">
                                                        <div className="_93-9">
                                                            <span>
                                                                <span className="_93-9-span">
                                                                    {kpiContent?.outOfOverallStock || "-"}
                                                                </span>
                                                                {kpiContent?.outOfOverallStock ? (
                                                                    <span className="_93-9-span2">%</span>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="title">
                                                    <div className="heading-4-total-visitors3">of overall stock</div>
                                                </div>
                                            </div>
                                            <div className="frame3">
                                                <div className="title">
                                                    <TooltipWSStock enabled={enabled} />
                                                    <div className="heading-4-total-visitors2 lh-normal">WS STOCK</div>
                                                </div>
                                                <div className="content3">
                                                    <div className="frame-3132894">
                                                        <div className="_102">{kpiContent?.supplierStock || "-"}</div>
                                                    </div>
                                                </div>
                                                <div className="title">
                                                    <div className="heading-4-total-visitors3"># of items</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </StyledKPIContent>
                </FormContainer>
            </StyledPage>
        </>
    );
    // #endregion
});

// #region SMALL COMPONENTS
const InfoCard = ({ cardTitle = "", value = "", currency = "", percentage = "", isActive = false, tooltip = null }) => {
    //TODO: tooltip currently disabled since it needs backend support to fetch data
    //tooltip = null;

    return (
        <div className={`id-info-card ${isActive ? "active" : ""}`}>
            <div className="frame-346">
                <div className="frame-161">
                    <div className="_333-360-nok-60">
                        <span>
                            <span className="_333-360-nok-60-span">{value}</span>
                            {currency && (
                                <span className="_333-360-nok-60-span2">
                                    {currency}
                                    <br />
                                </span>
                            )}
                            <span className="_333-360-nok-60-span3">{percentage}</span>
                        </span>
                    </div>
                </div>
                {tooltip === null ? (
                    <div className="gross-margin">{cardTitle}</div>
                ) : (
                    <>
                        <div className="flex justify-content-between w-100 align-items-end">
                            <div className="gross-margin">{cardTitle}</div>
                            <div className="tooltip-container">{tooltip}</div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

const getAccelerationText = enumVal => {
    const accelerationEnum = enumVal;
    const accelerationColor =
        accelerationEnum === "Rising" ? "#FFA500" : accelerationEnum === "Dimming" ? "#FF0000" : "#00AEEF";

    if (!accelerationEnum) return "-";

    return (
        <div className="flex items-center gap-4px">
            {accelerationEnum === "Rising" ? (
                <Sunrise0
                    alt="acceleration"
                    className="sunset align-self-center"
                    style={{ color: accelerationColor }}
                />
            ) : accelerationEnum === "Dimming" ? (
                <Sunset0 alt="acceleration" className="sunset align-self-center" style={{ color: accelerationColor }} />
            ) : accelerationEnum === "Idle" ? (
                <Hourglass
                    alt="acceleration"
                    className="sunset align-self-center"
                    style={{ color: accelerationColor }}
                />
            ) : (
                <></>
            )}
            <div className="_1-9-dimming">{accelerationEnum}</div>
        </div>
    );
};

const SalesChartTooltip = ({ data, getChartTooltipData }) => {
    const { dataPointIndex } = data;
    const tooltipData = getChartTooltipData(dataPointIndex) || {};

    const {
        date = "--",
        todayReturns = "--",
        todayUnitsSold = "--",
        todayWholeUnitsSold = "--",
        unitsSold = "--"
    } = tooltipData;

    return (
        <StyledSalesChartTooltip>
            <div className="styled-tooltip">
                <div className="tooltip-container">
                    Date: {formatDefaultDate(date)}
                    <br />
                    Consumer sales: {todayWholeUnitsSold} items
                    <br />
                    Returns: {todayReturns} items
                    <br />
                    Net items sold: {todayUnitsSold} items
                    <br />
                    Cumulative net sold: {unitsSold} items
                </div>
            </div>
        </StyledSalesChartTooltip>
    );
};
// #endregion
